// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/add-on-get-app-qrcode-slider/add-on-get-app-qrcode-slider.component.scss
// module id = 610
// module chunks = 0